import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCustomerDetailsRoute: InvariantJiraRoute = {
	name: 'servicedesk-customer-details',
	path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
	exact: true,
};
